// Rep's automatic ScriptTag installation must be disabled in its Shopify integration.
// This loader follows Consentmo's public permission API; it creates no separate banner.
(function () {
  'use strict';
  var loaded = false;
  var resetting = false;
  function allowed() {
    var cmp = window.Consentmo;
    return !!(cmp && typeof cmp.analyticsAllowed === 'function' && cmp.analyticsAllowed() === true
      && typeof cmp.marketingAllowed === 'function' && cmp.marketingAllowed() === true);
  }
  // Outside the consent regions Consentmo fires consentmoSignal_onLoad before window.Consentmo exists and
  // sends no later signal, so re-check once the API appears (bounded: 240 x 250 ms).
  var waiting = false;
  function waitForConsentmo() {
    if (waiting || window.Consentmo || typeof window.setInterval !== 'function') return;
    waiting = true;
    var tries = 0;
    var id = window.setInterval(function () {
      tries += 1;
      if (!window.Consentmo && tries < 240) return;
      window.clearInterval(id);
      waiting = false;
      if (window.Consentmo) update();
    }, 250);
  }
  function update() {
    if (!window.Consentmo) {
      waitForConsentmo();
      return;
    }
    if (!allowed()) {
      if (loaded && !resetting) {
        resetting = true;
        window.location.reload();
      }
      return;
    }
    if (loaded || resetting) return;
    loaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://d1o5e9vlirdalo.cloudfront.net/vfLoader.js';
    script.id = 'vfLoader';
    script.setAttribute('data-pk', 'renuebyscience2218.7787606092793');
    script.setAttribute('data-e', 'prod');
    document.head.appendChild(script);
  }
  document.addEventListener('consentmoSignal_onLoad', update);
  document.addEventListener('consentmoSignal', update);
  update();
})();
